import { gsap } from "gsap";
//import { fancybox } from "@fancyapps/ui";
//import  { fancybox }  from './jquery.fancybox.min';
import $ from 'jquery';
import screencheck from "./screencheck";

function filterSelect(elments, dropdownElement) {
    $(elments).each(function(){
        var $this = $(this),
            $selectTrigger = $this.find('.select-text'),
            $selectDropdown = $this.find('.select-dropdown');
        
        $selectTrigger.on('click', function(e){
            e.preventDefault();
            var $this = $(this),
                $selectDropdownBox = $this.next('.select-dropdown');
            if( $selectTrigger.is($this) && $selectTrigger.hasClass('open') ){
                // console.log('ifff');
            // if($(this).hasClass('open')){
                $this.removeClass('open');
                gsap.fromTo($selectDropdownBox, {opacity: 1, y:0, visibility:"visible"}, {opacity: 0, y:'-10px', visibility:"hidden", duration:0.350});
                // setTimeout (function(){
                //     $this.next('.select-dropdown').hide();
                // }, 200);
            } else {
                // if( $selectTrigger.is($selectDropdownBox) &&  $selectTrigger.hasClass('open') ){
                // // if($('.select-text').hasClass('open')){
                //     $('.select-text').removeClass('open');
                //     gsap.fromTo($('.select-dropdown'), {opacity: 1, y:0 }, {opacity: 0, y:'-10px', duration:0.350});
                //     setTimeout (function(){
                //         $('.select-dropdown').hide();
                //     }, 200);
                // }
                // console.log('else');
                if($('.select-text').hasClass('open')){
                    // console.log('else iffffff');
                    gsap.fromTo($selectDropdown, {opacity: 1, y:0, visibility:"visible" }, {opacity: 0, y:'-10px', visibility:"hidden", duration:0.350});
                    $('.select-text').removeClass('open');
                    gsap.fromTo($('.select-dropdown'), {opacity: 1, y:0, visibility:"visible" }, {opacity: 0, y:'-10px', visibility:"hidden", duration:0.350});
                    // $('.select-text').removeClass('open');
                    // gsap.fromTo($('.select-dropdown'), {opacity: 1, y:0 }, {opacity: 0, y:'-10px', duration:0.2});
                    // setTimeout (function(){
                    //     $('.select-dropdown').hide();
                    // }, 200);
                }
                // $selectTrigger.removeClass('open');
                // gsap.fromTo($selectDropdown, {opacity: 1, y:0 }, {opacity: 0, y:'-10px', duration:0.350});
                $(this).addClass('open');
                // $(this).next('.select-dropdown').show();
                gsap.fromTo($(this).next('.select-dropdown'), {opacity: 0, y:'-10px', visibility:"hidden" }, {opacity: 1, y:0, visibility:"visible", duration:0.350});
            }
        })
    });

    // Function to check checkbox items checked or not
    function checkCheckbox(elments) {
        if(elments > 0) {
            $('.filter-row').addClass('active');
        } else {
            $('.filter-row').removeClass('active');
        }
    }
    checkCheckbox($('.dropdown-checkboxes').find('.checkbox input[type="checkbox"]:checked').length);

    // Dropdown checkbox filter count
    $(dropdownElement).each(function(){
        var $this = $(this),
            $checkboxItem = $this.find('.checkbox input[type="checkbox"]'),
            $checkboxCheckedItem = 0;
        $($checkboxItem).click(function(){
            $checkboxCheckedItem = $(this).parents('.dropdown-checkboxes').find('.checkbox input[type="checkbox"]:checked').length;
            var $filterAllCheckedItems = $(this).parents('.filter-row').find('.checkbox input[type="checkbox"]:checked').length;
            $(this).parents('.custom-select').find('.filter-number').text($checkboxCheckedItem);
            if($checkboxCheckedItem > 0){
                $(this).parents('.custom-select').find('.filter-number').show();
            } else {
                $(this).parents('.custom-select').find('.filter-number').hide();
            }

            // if($filterAllCheckedItems > 0) {
            //     $('.filter-row').addClass('active');
            // } else {
            //     $('.filter-row').removeClass('active');
            // }
            checkCheckbox($filterAllCheckedItems);
        })
    });

    // Close dropdown on click outside
    $(document).on('click', function(e){
        $('.select-text').each(function(){
            var $this = $(this);
            if($this.hasClass('open')){
                // console.log('document click');
                // console.log(e.target);
                if(!$(e.target).parents('.custom-select').length){
                    // console.log('etarget hide');
                    $this.removeClass('open');
                    gsap.fromTo($this.next('.select-dropdown'), {opacity: 1, y:0, visibility:"visible" }, {opacity: 0, y:'-10px', visibility:"hidden", duration:0.350});
                    // setTimeout (function(){
                    //     $('.select-dropdown').hide();
                    // }, 200);
                }
            }
        })
    });

    // $('a[data-fancybox]').fancybox({
    //     openEffect: 'elastic',
    //     closeEffect: 'elastic',
    // });

    // Filter reset button on mobile
    
    if($('.filter-reset').length) {
        $(".filter-section").each(function () {
            let $this = $(this);
            let filterResetBtn = $this.find(".filter-reset");
            $(window).on('resize', function(){
                if (screencheck(767)) {
                    if(!$this.find(".filter-block .filter-title .filter-reset").length){
                        filterResetBtn.appendTo($this.find('.filter-head .filter-title'));
                    }
                } else {
                    if(!$this.find(".filter-row > .filter-reset").length){
                        filterResetBtn.appendTo($this.find('.filter-head .filter-row'));
                    }
                }
            }).resize();
        })
        // $(window).on('resize', function(){
        //     if (screencheck(767)) {
        //         // $('.filter-reset').appendTo($('.filter-reset').parents('.filter-row').find('.filter-title'));
        //         if(!$(".filter-section .filter-block .filter-title .filter-reset").length){
        //             console.log('in');
                    
        //             $('.filter-reset').appendTo($('.filter-reset').parents('.filter-row').find('.filter-block:first').children('.filter-title'));
        //         }
        //     } else {
        //         // $('.filter-reset').appendTo($('.filter-reset').parents('.filter-row'));
        //         if(!$(".filter-section .filter-row > .filter-reset").length){
        //             console.log('out');
        //             $('.filter-reset').appendTo($('.filter-reset').parents('.filter-row'));
        //         }
        //     }
        // }).resize();
    }

    if($('.filter-categories').length) {
        $(document).on('click', '.filter-categories > .tag, .filter-location > .tag', function(){
            var $this = $(this);
            if($this.hasClass('active')){
                $this.removeClass('active');
            } else {
                $this.addClass('active');
            }
            if($('.filter-categories > .tag.active').hasClass('active') || $('.filter-location > .tag.active').hasClass('active')) {
                $('.filter-categories, .filter-location').addClass('active');
                $('.filter-row').addClass('active');
            } else {
                $('.filter-categories, .filter-location').removeClass('active');
                $('.filter-row').removeClass('active');
            }
            return false;
        })
    }


    // Filter reset button
    $(document).on('click', '.filter-btn', function(){
        if($(this).parents('.filter-row').find('.filter-categories').length || $(this).parents('.filter-row').find('.filter-location').length) {
            $(this).parents('.filter-row').find('.filter-categories, .filter-location').removeClass('active');
            $(this).parents('.filter-row').find('.filter-categories > .tag, .filter-location > .tag').removeClass('active');
        } else {
            // $(this).parents('.filter-row').find('.dropdown-checkboxes').find('.checkbox input[type="checkbox"]').prop('checked', false).removeAttr('checked');
            $(this).parents('.filter-row').find('.dropdown-checkboxes').find('.checkbox input[type="checkbox"]').prop('checked', false);
            $(this).parents('.filter-row').find('.dropdown-checkboxes').find('.checkbox input[type="checkbox"]').removeAttr('checked');
            $(this).parents('.filter-row').find('.filter-number').text(0).hide();
        }
        $(this).parents('.filter-row').removeClass('active');
        return false;
    })
    

    

};

// module.exports = filterSelect;
export default filterSelect;